import { MeiliSearch } from 'meilisearch';
import { meiliHost, meiliApiKey, meilisearchSuggestionsIndex } from '../algoliaSettings';

function createMeiliClient() {
    const host = meiliHost();
    const apiKey = meiliApiKey();

    if (!host || !apiKey) {
        return null;
    }

    return new MeiliSearch({ host, apiKey });
}

async function fetchSuggestions(query) {
    const indexName = meilisearchSuggestionsIndex();

    if (!indexName || !query) {
        return [];
    }

    const client = createMeiliClient();

    if (!client) {
        return [];
    }

    try {
        const result = await client.index(indexName).search(query, { limit: 5 });

        return result.hits;
    } catch {
        return [];
    }
}

export function createMeiliSearchSuggestionsPlugin({ templates = {}, onSelect } = {}) {
    return {
        getSources({ query }) {
            return [
                {
                    sourceId: 'querySuggestionsPlugin',
                    async getItems() {
                        return fetchSuggestions(query);
                    },
                    getItemInputValue({ item }) {
                        return item.query;
                    },
                    templates,
                    onSelect,
                },
            ];
        },
    };
}